import "./components/styles.css"
import Header from './components/Header.js';
import Main from './components/Main.js';
import Footer from './components/Footer.js'
function App() {
  return (
    <div className="body-grid">

      <Header />

      <Main />

      <Footer />

    </div>
  );
}

export default App;
